<template>
    <div class="">
        <div class="p-4" v-for="response in question.responses.correct_answers" :key="response.text">
            <div class="rounded col-span-2 flex space-x-2">
                <CorrectIncorrectIcon :is-correct="true" />
                <span class="pl-1">
                    {{ response.text }}
                </span>
                <div class="inline-block" style="min-height: 32px">
                    <StudentsProfileStackFiltered
                        :students="students"
                        :selected="response.student_ids"
                        class="inline-block"
                    />
                </div>
                <div v-if="response.percent !== null && withPercent">
                    <span> {{ response.percent }}% </span>
                    <span v-if="response.count !== null" class="text-sm text-gray-500 pl-1"
                        >({{ response.count }})</span
                    >
                </div>
            </div>
        </div>

        <div class="p-4" v-for="response in question.responses.other" :key="response.text">
            <div class="rounded col-span-2 flex space-x-2">
                <div v-if="isTeacherMode">
                    <input
                        name="selected"
                        v-model="form.new_correct_answers"
                        type="checkbox"
                        :value="response.text"
                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                    />
                </div>
                <CorrectIncorrectIcon :is-correct="false" />
                <span class="pl-1">
                    {{ response.text }}
                </span>
                <div class="inline-block" style="min-height: 32px">
                    <StudentsProfileStackFiltered
                        :students="students"
                        :selected="response.student_ids"
                        class="inline-block"
                    />
                </div>
                <div v-if="response.percent !== null && withPercent">
                    <span> {{ response.percent }}% </span>
                    <span v-if="response.count !== null" class="text-sm text-gray-500 pl-1"
                        >({{ response.count }})</span
                    >
                </div>
            </div>
        </div>
        <transition
            enter-active-class="transition ease-linear duration-200"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition ease-linear duration-150"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div v-if="form.new_correct_answers.length > 0">
                <AppWell>
                    <form action="" @submit.prevent="addCorrect">
                        <AppCard>
                            <AppButton element="button" type="submit" desired-action>
                                {{ $tc('messages.mark_answers_as_correct', form.new_correct_answers.length) }}
                            </AppButton>
                            {{ form.new_correct_answers.join(', ') }}
                        </AppCard>
                    </form>
                </AppWell>
            </div>
        </transition>

        <div class="p-4 rounded col-span-2 flex space-x-2" v-if="question.responses.unanswered">
            <svg
                class="w-6 h-6 text-gray-300"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z"
                    clip-rule="evenodd"
                ></path>
            </svg>
            <span class="pl-1">
                {{ question.responses.unanswered.text }}
            </span>
            <template v-if="question.responses.unanswered">
                <div class="inline-block" style="min-height: 32px">
                    <StudentsProfileStackFiltered
                        :students="students"
                        :selected="question.responses.unanswered.student_ids"
                        class="inline-block"
                    />
                </div>
                <div v-if="question.responses.unanswered.percent !== null && withPercent">
                    <span> {{ question.responses.unanswered.percent }}% </span>
                    <span v-if="question.responses.unanswered.count !== null" class="text-sm text-gray-500 pl-1"
                        >({{ question.responses.unanswered.count }})</span
                    >
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import CorrectIncorrectIcon from '@/components/Quiz/CorrectIncorrectIcon.vue';
import StudentsProfileStackFiltered from '@/components/StudentsProfileStackFiltered.vue';
import AppWell from '@/Shared/AppWell.vue';
import AppCard from '@/Shared/AppCard.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    name: 'QuestionShortAnswerReview',
    components: {
        AppButton,
        AppCard,
        AppWell,
        CorrectIncorrectIcon,
        StudentsProfileStackFiltered,
    },
    data() {
        return {
            form: this.$inertia.form({
                new_correct_answers: [],
            }),
        };
    },
    props: {
        question: {
            required: true,
        },
        withPercent: {
            required: false,
            default: false,
            type: Boolean,
        },
        isTeacherMode: {
            required: false,
            default: false,
            type: Boolean,
        },
        students: {
            required: true,
            type: Array,
        },
    },
    methods: {
        addCorrect() {
            this.$inertia.patch(
                this.question.quick_update_url,
                {
                    new_correct_answers: this.form.new_correct_answers,
                },
                {
                    preserveScroll: true,
                },
            );
        },
    },
};
</script>
